import React, { Component } from 'react';
import { connect } from 'react-redux';

import lodashGet from 'lodash/get';
import lodashFind from 'lodash/find';

import { Box, Button, Grid, IconButton, InputAdornment, TableContainer, TextField, Typography } from '@mui/material';
import { ThumbnailParcelShapeFromPathInfos } from '../../thumbnail/ThumbnailParcelShape';
import UpdateParcelInfo from '../../commonStructures/updateParcelInfo';
import CustomDataGrid from '../../customDataGrid';

import EditIcon from '@mui/icons-material/Edit';
import DoneIcon from '@mui/icons-material/Done';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

import { ActionManageExternalInfos, ActionSelectParcelsForExternalInfos } from '../../../redux/actions/lastNitrogenInput';
import { ActionOpenParcelEdit, ActionShowProfilMenuDialog, ProfilIndex } from '../../../redux/actions/contextApp';
import { TableType } from '../../../redux/actions/settings';
import { FertilizerEngineEnumValue } from '../../../redux/actions/fertilizer';

import dicoFunction from '../../../datas/dicoDetails';
import { ParcelsHelper } from '../../../utils/parcelsHelper';
import DateHelper from '../../../utils/dateHelper';
import stringHelper from '../../../utils/stringHelper';

import StringTranslate from '../../../assets/i18n/stringLanguage';

/* theme Berry */
import getTheme from "../../../themes/index.js";
import { enumCultureGlobal} from '../../../models/constantEnumCulture';
import { CropHelper } from '../../../utils/cropHelper';

let theme = getTheme();

class LastNitrogenInputExternalParcelChoice extends Component {
    constructor(props) {
        super(props);

        this.state = {
            datas: this.initialiseDatas(props.parcelIdFilteredList), //lignes des parcelles

            parcelsSelected: (props.parcelIdsSelected !== undefined) && (props.parcelIdsSelected.length > 0) ? props.parcelIdsSelected : [], //parcelles sélectionnées par les checkbox

            searchFilter: '', // zone de recherche du tableau
            currentRowsOfTable: [], // Datas filtré par rapport à la recherche
        }
        
        // liste des noms de colonnes affichées
        this.columns = this.initialiseColumns(props.parcelIdFilteredList); //RQ: pas dans le 'state' car on en utilise des propriétés !
        this.CustomToolbar = this.CustomToolbar.bind(this);
    }

    componentDidMount() {
        const { datas } = this.state;

        this.sortDatasByCrop(datas);
    }
    
    componentDidUpdate(prevProps, prevState) {
        const { openEditParcel, parcelIdFilteredList } = this.props;
        const { searchFilter } = this.state;

        // Suite à fermeture popup de modif de parcelle
        if ((prevProps.openEditParcel === true) && (openEditParcel === false)) {
            // On recharge les données potentiellement modifiées

            const newDatas = this.initialiseDatas(parcelIdFilteredList);
     
            this.setState({
                datas: newDatas,
            });
            this.sortDatasByCrop(newDatas);
            this.requestSearch(searchFilter, newDatas);
        }
    }

    /**
     * Fonction permettant la création des colonnes à afficher
     * @param {number[]} parcelIdFilteredList 
     * @returns 
     */
    initialiseColumns(parcelIdFilteredList) {
        const { parcelDico, openParcelEdit } = this.props;

        let newColumns = [];
        if (parcelIdFilteredList && parcelIdFilteredList[0]) {

            /* ↓ ajout colonne visible - (booléen parcelle ajustée) ↓ */
            newColumns.push({
                headerName: `Déjà ajusté ?`,
                field: "isAdjusted",
                width: 80,
                hideable: false,
                renderHeader: (params) => {
                    return (<Typography sx={{ textWrap: 'wrap', }} fontWeight='bold' >{StringTranslate.parcelHasLastInputN}</Typography>)
                },
                renderCell: params => (
                    (params.value === true) ?
                        <DoneIcon style={{ color: theme.palette.success.main }} />
                        : <></>
                ),
            });

            // Bouton pour modifier les données de parcelles
            newColumns.push({
                field: 'actions',
                editable: false,
                hideable: false,
                headerName: '',
                width: 60,
                renderCell: params => {
                    return (
                        <IconButton onClick={() => openParcelEdit(params.value, params.row.thumbnailInfos)}>
                            <EditIcon color="inherit" />
                        </IconButton>
                    )
                }
            });

            /* ↓ ajout colonne visible - (Miniature + nom de la parcelle) ↓ */
            newColumns.push({
                headerName: `${StringTranslate.nomcolumn}`,
                field: "nom",
                minWidth: 180,
                hideable: false,
                renderHeader: (params) => {
                    return (<Typography fontWeight='bold' >{StringTranslate.nomcolumn}</Typography>)
                },
                renderCell: params => {
                    return (
                        <Box style={{ display: "flex", flexDirection: "row", alignItems: "center" }} >
                            {(params) ? (<ThumbnailParcelShapeFromPathInfos id={`listItemTbl_${params.row.thumbnailInfos.parcelId}`} {...params.row.thumbnailInfos} />) : (undefined)}
                            <Typography>{params.value}</Typography>
                        </Box>
                    )
                }
            });

            const firstParcel = ParcelsHelper.selectParcelFromDicoById(parcelDico, parcelIdFilteredList[0]);
            if (firstParcel && firstParcel.details) {
                const dico = dicoFunction();
                for (let detail in firstParcel.details) {
                    dico.forEach(column => {
                        if (detail === column.name) {
                            if (column.name === "variete") {
                                newColumns.push({
                                    headerName: column.libeleColumn,
                                    field: column.name,
                                    minWidth: 150,
                                    hideable: false,
                                    renderHeader: (params) => {
                                        return (<Typography fontWeight='bold' >{column.libeleColumn}</Typography>)
                                    },
                                });
                            }
                            else if (column.name === "exploitation") {
                                newColumns.push({
                                    headerName: column.libeleColumn,
                                    field: column.name,
                                    minWidth: 150,
                                    hideable: false,
                                    renderHeader: (params) => {
                                        return (<Typography fontWeight='bold' >{column.libeleColumn}</Typography>)
                                    },
                                });
                            }
                            else if (column.name === "dateSemi") {
                                newColumns.push({
                                    headerName: column.libeleColumn,
                                    field: column.name,
                                    width: 110,
                                    type: "date",
                                    hideable: false,
                                    renderHeader: (params) => {
                                        return (<Typography fontWeight='bold' >{column.libeleColumn}</Typography>)
                                    },
                                });
                            }
                            else if (column.name === "campagne") {
                                newColumns.push({
                                    headerName: column.libeleColumn,
                                    field: column.name,
                                    width: 100,
                                    type: "date",
                                    hideable: false,
                                    renderHeader: (params) => {
                                        return (<Typography fontWeight='bold' >{column.libeleColumn}</Typography>)
                                    },
                                });
                            }
                            else if (column.name === "culture" || column.name === "culturePrecedente") {
                                newColumns.push({
                                    headerName: (column.name === "culture" ?
                                        `${StringTranslate.libelecolumnculture}` :
                                        `${StringTranslate.libelecolumncultureprece}`),
                                    field: column.name,
                                    minWidth: 150,
                                    hideable: false,
                                    renderHeader: (params) => {
                                        return (<Typography fontWeight='bold' >{column.libeleColumn}</Typography>)
                                    },
                                });
                            }
                            else if (column.name === "surface") {
                                newColumns.push({
                                    headerName: column.libeleColumn,
                                    field: column.name,
                                    width: 100,
                                    hideable: false,
                                    renderHeader: (params) => {
                                        return (<Typography fontWeight='bold' >{column.libeleColumn}</Typography>)
                                    },
                                });
                            }
                            else {
                                newColumns.push({
                                    headerName: column.libeleColumn,
                                    field: column.name,
                                    hideable: false,
                                    renderHeader: (params) => {
                                        return (<Typography fontWeight='bold' >{column.libeleColumn}</Typography>)
                                    },
                                });
                            }
                        }
                    });
                }
            }
        }
        return newColumns;
    }

    /* fonction permettant d'extraire les données qui seront utilisées dans le visuel */
    initialiseDatas(parcelIdFilteredList) {
        const { parcelDico, thumbnailParcelDico, fertilizerDico, } = this.props;
        let parcels = ParcelsHelper.getParcelsDicoFromParcelIdList(parcelDico, parcelIdFilteredList);
        let newDatas = [];

        for (var itemPropName in parcels) {
            let temp = [];
            const parcel = parcels[itemPropName];

            if (parcel) {
                const thumbnailParcelItem = ParcelsHelper.selectParcelFromDicoById(thumbnailParcelDico, parcel.id);

                temp.push(parcel.id);
                temp.push(parcel.name);
                if (parcel.details) {
                    for (let itemDetailName in parcel.details) {
                        const propValue = parcel.details[itemDetailName];
                        let value = (propValue) ? propValue : '';
                        if (itemDetailName.toLowerCase() === 'datesemi') {
                            if (propValue && (propValue instanceof (Date))) {
                                value = DateHelper.formati18n(propValue, 'P');
                            }
                            else if (propValue && (DateHelper.getDateFromString(propValue) instanceof Date)) {
                                value = DateHelper.formati18n(new Date(propValue), 'P');
                            }
                        }
                        else if (itemDetailName.toLowerCase() === 'surface') {
                            if(parcel.area && (parcel.area > 0)) {
                                value = parcel.area;
                            }
                        }
                        temp.push(value);
                    }
                }

                let ferti = lodashFind(Object.values(fertilizerDico), { idParcel: parcel.id, isArchived: false });
                let isAdjusted = lodashGet(ferti, 'hasLastNitrogenInput', false);
                let fertiEngine = lodashGet(ferti, 'engine', FertilizerEngineEnumValue.UNKNOWN);
                let isComplet = lodashGet(ferti, 'isComplet', false);

                if ((fertiEngine === FertilizerEngineEnumValue.UNKNOWN) || (fertiEngine === FertilizerEngineEnumValue.EXTERNE) || (isComplet === false)) {
                    newDatas.push({
                        id: parcel.id,
                        actions: parcel,
                        parcel: parcel,
                        isAdjusted: isAdjusted,
                        nom: parcel.name,
                        campagne: temp[2],
                        culture: parcel.details.length < 4 ? null : temp[3],
                        culturePrecedente: parcel.details.length < 5 ? null : temp[4],
                        dateSemi: parcel.details.length < 6 ? null : temp[5],
                        exploitation: parcel.details.length < 7 ? null : temp[6],
                        surface: parcel.details.length < 8 ? null : temp[7],
                        variete: parcel.details.length < 9 ? null : temp[8],
                        thumbnailInfos: thumbnailParcelItem,
                    });
                }
                

            }
        }
        return newDatas;
    }

    /* Fonction correspondant à la zone de recherche uniqueent sur la culture */
    requestSearch(searchValue, rowsOfTable) {
        this.setState({
            searchFilter: searchValue
        });

        try {
            const searchRegex = new RegExp(stringHelper.escapeRegExp(searchValue), 'i');
            const filteredRows = rowsOfTable.filter((row) => {
                return Object.keys(row).some((field) => {
                    let textValue = "" + row[field];
                    return searchRegex.test(textValue.toString());
                });
            });

            this.setState({
                currentRowsOfTable: filteredRows
            });
        }
        catch (errRegex) { /* Peut arriver si on saisis un truc du genre 'EARL++' ! (il n'aime pas les '++') */ }
    }

    //Sélection des parcelles pour commencer la pesée de colza
    setSelectionParcels = (newSelectionParcels) => {
        this.setState({
            parcelsSelected: newSelectionParcels
        });
    }

    //Toolbar customisé du tableau comprenant :
    // - la zone de recherche
    // - le bouton pour commencer la saisi des infos
    CustomToolbar = (props) => {
        const { showProfilMenuDialog, } = this.props;
        return (
            <Grid container spacing={2} sx={{ mt: 2 }}>
                {/* Zone de recherche / zone du bouton de validation*/}
                <Grid item xs={12} sx={{ mt: 2 }}>
                    <Grid container spacing={1}>
                        {/* Zone de recherche */}
                        <Grid item xs={6} sm={8} md={4} lg={4}>
                            <TextField
                                value={props.value}
                                onChange={props.onChange}
                                placeholder={StringTranslate.toolbarsearch}
                                size="small"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon fontSize="small" />
                                        </InputAdornment>),
                                    endAdornment: (
                                        <IconButton
                                            title="Clear"
                                            aria-label="Clear"
                                            size="small"
                                            style={{ visibility: props.value ? 'visible' : 'hidden' }}
                                            onClick={props.clearSearch}
                                        >
                                            <ClearIcon fontSize="small" />
                                        </IconButton>
                                    ),
                                }}
                            />
                        </Grid>

                        {/* Zone de validation des parcelles sélectionnées */}
                        <Grid item xs={6} sm={4} md={8}>
                            <Box style={{ textAlign: 'end' }} >
                                <Button
                                    disabled={!props.canGoToNextStep}
                                    variant="contained"
                                    color="primary"
                                    onClick={props.selectParcels}>
                                    {StringTranslate.validSlots}
                                </Button>
                            </Box>

                        </Grid>
                    </Grid>
                </Grid>
                {/* Bouton d'aide */}
                <Grid item xs={12}>
                    <Button color="secondary" variant="text" size="small" onClick={() => showProfilMenuDialog(ProfilIndex.aide_LastNitrogenInput)}>
                        {StringTranslate.helpAsk}
                    </Button>
                </Grid>
            </Grid>
        );
    }

    sortDatasByCrop = (datas) => {
        const { parcelIdFilteredList } = this.props;
        const { parcelsSelected } = this.state;

        let resultSortParcel = CropHelper.sortDataByCrop(datas, parcelIdFilteredList, enumCultureGlobal.ble);

        this.setState({
            datas: resultSortParcel.parcelsList,
            parcelsSelected: (resultSortParcel.parcelIdsSelected.length <= 0) ? parcelsSelected : resultSortParcel.parcelIdsSelected,
        });
    };

    render() {
        const { datas, searchFilter, currentRowsOfTable, parcelsSelected } = this.state;
        const { openEditParcel, rowsPerPageForTableParcels, showProfilMenuDialog,
            goBack, selectParcels } = this.props

        return (
            <>
                {openEditParcel ?
                    <UpdateParcelInfo/>
                    :<></>
                }
                <TableContainer>
                    <Grid style={{ width: '100%' }} item xs={12}>
                        {/* partie tableau */}
                        <CustomDataGrid
                            disableSelectionOnClick={true}
                            tableName={TableType.parcels}
                            pageSize={rowsPerPageForTableParcels}
                            rows={(searchFilter !== "") ? currentRowsOfTable : datas }
                            columns={this.columns}
                            checkBoxActive={true}
                            selectionModel={parcelsSelected}
                            onSelectionModelChange={(newSelectionParcels) => { //Sélection des parcelles par clic checkbox
                                this.setSelectionParcels(newSelectionParcels);
                            }}
                            keepNonExistentRowsSelected={searchFilter !== "" ? true : false}
                            Toolbar={this.CustomToolbar}
                            toolbar={{
                                // Validation de sélection
                                canGoToNextStep: (parcelsSelected?.length > 0),
                                selectParcels: () => selectParcels(parcelsSelected),

                                //Concerne la zone de recherche dans le tableau :
                                value: searchFilter,
                                onChange: (event) => this.requestSearch(event.target.value, datas),
                                clearSearch: () => this.requestSearch('', datas),

                                // Accès menu d'aide
                                showProfilMenuDialog: (index) => showProfilMenuDialog(index),
                            }}
                        />
                    </Grid>
                </TableContainer>

                {/* Boutons :
                 - retour vers l'étape 1 (choix des parcelles) */}
                <Grid container marginTop={3}>
                    <Grid item xs={4} sm={4}>
                        <Button 
                            variant="text" 
                            onClick={goBack}
                        >
                            {StringTranslate.revenir}
                        </Button>
                    </Grid>
                    <Grid item xs={6} sm={4}>

                    </Grid>

                    <Grid item xs={12} sm={4} sx={{ [theme.breakpoints.only('xs')]: { marginTop: 1 } }}>

                    </Grid>
                </Grid>
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        fertilizerDico: lodashGet(state, 'fertilizerData.fertilizerDico', {}),

        parcelIdsSelected: lodashGet(state, 'lastNitrogenInputData.parcelIdsSelectedForExternalInfos', []),
    
        parcelDico: lodashGet(state, 'parcelsData.parcelDico', {}),
        thumbnailParcelDico: lodashGet(state, 'parcelsData.thumbnailParcelDico', {}),
        parcelIdFilteredList: lodashGet(state, 'parcelsData.parcelIdFilteredList', {}),
        parcelIdFilteredListCounter: lodashGet(state, 'parcelsData.parcelIdFilteredListCounter', 0),

        openEditParcel: lodashGet(state, 'contextAppData.openDialogParcelEdit', false),

        language: lodashGet(state, 'settingsData.settings.language', StringTranslate.getLanguage()), // Permet de raffraichir le composant lors d'un changement de langue
        rowsPerPageForTableParcels: lodashGet(state, 'settingsData.settings.rowsPerPageForTableParcels', 20),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        goBack: () => dispatch(ActionManageExternalInfos(false)),
        selectParcels: (parcelIds) => dispatch(ActionSelectParcelsForExternalInfos(parcelIds)),

        openParcelEdit: (parcel, thumbnailInfos) => dispatch(ActionOpenParcelEdit(parcel, thumbnailInfos)),

        showProfilMenuDialog: (index) => dispatch( ActionShowProfilMenuDialog(index) ),
    };
}

export default connect(mapStateToProps,mapDispatchToProps)(LastNitrogenInputExternalParcelChoice);